import React from 'react'
import PortfolioMenu from './PortfolioMenu'

const PortfolioMenuIntroMobile = () => {
  return (
    <div className="portfolio-menu-intro-mobile">
      <PortfolioMenu />
    </div>
  )
}

export default PortfolioMenuIntroMobile 


// WEBPACK FOOTER //
// ./src/PortfolioMenuIntroMobile.js